import React from "react";
import { CopyrightCashParking } from "../cashparking/CopyrightCashParking";
import { PrivacyPolicy } from "../commonComponents/PrivacyPolicy";
import classes from "./ModernLayout.module.scss";

export function ModernFooter() {
  return (
    <footer className={ classes.modernFooter } data-testid="modernFooter">
      <div className={ classes.footerContent }>
        <CopyrightCashParking />
        <PrivacyPolicy />
      </div>
    </footer>
  );
}
